import React from 'react'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { FormField } from '@pff-consumer/tweed-ui/molecules/form-field/form-field.web'
import { Input } from '@pff-consumer/tweed-ui/atoms/input/input.web'
import { Text, TextDescriptionVariant } from '@pff-consumer/tweed-ui/atoms/browser-text'
import { colors } from '@pff-consumer/core-ui'
import { useStyles } from './customer-email.web.styles'

const { useCheckoutActions, useEmailErrorMessage, useEmail, useNewsLetterPreference } = checkoutHooks

export const CustomerEmail = () => {
  const { updateEmail, toggleNewLetterPreference } = useCheckoutActions()
  const errorMessage = useEmailErrorMessage()
  const email = useEmail()
  const styles = useStyles()
  const hasOptedInForNewsLetter = useNewsLetterPreference()

  const handleEmail = (e: any) => {
    updateEmail(e.target.value)
  }

  return (
    <div className={styles.oneStepCheckoutEmailContainer}>
      <FormField
        label='Email'
        isRequired
        errorMessage={errorMessage}
      >
        <Input
          id='email'
          type='email'
          required
          placeholder='Email'
          defaultValue={email}
          onBlur={handleEmail}
          isError={!!errorMessage}
        />
      </FormField>
      <div className={styles.newsletterCheckboxContainer}>
        <input
          type='checkbox'
          className={styles.newsletterCheckbox}
          id='newsletterCheckbox'
          checked={hasOptedInForNewsLetter}
          onChange={toggleNewLetterPreference}
        />
        <label htmlFor='newsletterCheckbox'>
          <Text
            variant={TextDescriptionVariant.SMALL_PRIMARY_REGULAR}
            colorOverride={colors.webFadedTextColor}
          >
            Sign me up to receive exclusive promotions, news, and other features from PFF via email
          </Text>
        </label>
      </div>
    </div>
  )
}
